import React from "react";
import { Megaphone, Code2, ArrowRight } from "lucide-react";
import { Reveal } from "../lib/motion";
import { IMG } from "../data/site";

const BLOCKS = [
  {
    icon: Megaphone,
    title: "Marketing",
    text: "Strategia, kampanie, branding osobisty, pozyskiwanie ruchu i monetyzacja.",
    img: IMG.agencies,
    accent: "coral",
  },
  {
    icon: Code2,
    title: "Technologia",
    text: "Własne narzędzia, automatyzacja, bezpieczeństwo i skalowanie biznesu.",
    img: IMG.independent,
    accent: "violet",
  },
];

export const MoreThanAgency = () => {
  return (
    <section className="relative py-[clamp(64px,9vw,120px)]" data-testid="more-section">
      <div className="container-pm">
        <Reveal className="text-center mb-14">
          <p className="eyebrow mb-4">Dla twórczyń, agencji i managerów</p>
          <h2 className="font-display font-semibold text-white text-[clamp(34px,4.4vw,58px)] leading-[1.02] tracking-[-0.035em]">
            PMPOINT to <span className="text-coral">więcej niż agencja.</span>
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-6">
          {BLOCKS.map((b, i) => {
            const isCoral = b.accent === "coral";
            const Icon = b.icon;
            return (
              <Reveal key={b.title} delay={i * 0.12} className="group">
                <div className="pm-card relative overflow-hidden h-[300px] flex">
                  <img
                    src={b.img}
                    alt={b.title}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
                    style={{ objectPosition: "right center" }}
                    width="640"
                    height="360"
                  />
                  <div className="absolute inset-0 photo-overlay" />
                  <div className="relative z-10 p-8 flex flex-col justify-center max-w-[62%]">
                    <Icon size={26} style={{ color: isCoral ? "var(--coral)" : "var(--violet)" }} className="mb-4" />
                    <h3
                      className="font-display font-semibold text-2xl mb-2"
                      style={{ color: isCoral ? "var(--coral)" : "var(--violet)" }}
                    >
                      {b.title}
                    </h3>
                    <p className="text-sm text-white/75 mb-5">{b.text}</p>
                    <a
                      href="#aplikuj"
                      data-testid={`more-cta-${b.title}`}
                      className="inline-flex w-fit items-center gap-2 h-10 px-4 rounded-lg text-sm font-bold text-white transition-transform hover:-translate-y-0.5"
                      style={{ background: isCoral ? "var(--coral)" : "var(--violet)" }}
                    >
                      Zobacz więcej <ArrowRight size={15} />
                    </a>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
